import React from 'react';
import { useTranslation } from 'react-i18next';

export default function Terms() {
  const { i18n } = useTranslation();
  const isZh = i18n.language === 'zh';
  const tt = (en, zh) => (isZh ? zh : en);

  const sectionStyle = { backgroundColor: '#0d2818', borderColor: '#c9a961' };

  return (
    <div className="min-h-screen px-4 pt-24 pb-32" style={{ backgroundColor: '#1a3a2a' }}>
      <div className="max-w-3xl mx-auto">
        <h1 className="text-headline-lg font-bold mb-2" style={{ color: '#c9a961' }}>
          {tt('Terms and Conditions', '条款与条件')}
        </h1>
        <p className="text-body-sm mb-8" style={{ color: '#999999' }}>
          {tt('Please read these terms carefully before purchasing a package or using Wellis services.', '在购买套餐或使用 Wellis 服务之前，请仔细阅读以下条款。')}
        </p>

        <div className="border rounded-lg p-6 mb-6 space-y-3" style={sectionStyle}>
          <h2 className="text-headline-sm font-bold" style={{ color: '#c9a961' }}>
            {tt('Refund Policy', '退款政策')}
          </h2>
          <p className="text-body-sm leading-relaxed" style={{ color: '#b8a68f' }}>
            {tt(
              'Funds paid for a package are subject to a 50% administrative charge if refunded. This means a member who requests and is approved for a refund will receive 50% of the amount originally paid; the remaining 50% is retained as an administrative charge and is non-recoverable.',
              '已支付的套餐款项如需退款，将收取 50% 的行政费用。这意味着会员申请并获批退款后，将获得原支付金额的 50%；其余 50% 将作为行政费用保留，不可退还。'
            )}
          </p>
          <p className="text-body-sm leading-relaxed" style={{ color: '#b8a68f' }}>
            {tt(
              'Refund requests must be submitted to the Wellis support team or your sponsor and are subject to admin review and approval before processing.',
              '退款申请须提交给 Wellis 支持团队或您的推荐人，并须经管理员审核批准后方可处理。'
            )}
          </p>
        </div>

        <div className="border rounded-lg p-6 mb-6 space-y-3" style={sectionStyle}>
          <h2 className="text-headline-sm font-bold" style={{ color: '#c9a961' }}>
            {tt('Payments', '付款')}
          </h2>
          <p className="text-body-sm leading-relaxed" style={{ color: '#b8a68f' }}>
            {tt(
              'Package purchases may be made by card payment, PayNow, or other methods made available at checkout. Payments made via PayNow or other manual methods are subject to review and confirmation by an administrator before the corresponding package is activated on your account.',
              '套餐购买可通过银行卡付款、PayNow 或结账时提供的其他方式进行。通过 PayNow 或其他人工方式付款的，须经管理员审核确认后，相应套餐方可在您的账户中激活。'
            )}
          </p>
        </div>

        <div className="border rounded-lg p-6 mb-6 space-y-3" style={sectionStyle}>
          <h2 className="text-headline-sm font-bold" style={{ color: '#c9a961' }}>
            {tt('Account Responsibility', '账户责任')}
          </h2>
          <p className="text-body-sm leading-relaxed" style={{ color: '#b8a68f' }}>
            {tt(
              'You are responsible for keeping your Wellis ID and password confidential. Wellis is not liable for losses resulting from unauthorized access to your account due to your failure to safeguard your login credentials.',
              '您有责任对您的 Wellis ID 和密码保密。因您未能妥善保管登录凭证而导致账户被未经授权访问所造成的损失，Wellis 概不负责。'
            )}
          </p>
        </div>

        <div className="border rounded-lg p-6 space-y-3" style={sectionStyle}>
          <h2 className="text-headline-sm font-bold" style={{ color: '#c9a961' }}>
            {tt('Contact', '联系方式')}
          </h2>
          <p className="text-body-sm leading-relaxed" style={{ color: '#b8a68f' }}>
            {tt(
              'Questions about these terms can be directed to your sponsor or the Wellis support team.',
              '如对本条款有任何疑问，请联系您的推荐人或 Wellis 支持团队。'
            )}
          </p>
        </div>
      </div>
    </div>
  );
}
